import type { CartLineItem } from '@/types/checkout';
import { cn } from '@/utils/cn';
import { getCartLineItemAssetUrl, getCartLineItemDisplayName, getCartLineItemKey } from '@/utils/offers';
import { useTranslate } from '@/hooks/useTranslate';

export const OfferThumbnailStack = ({
  lineItems,
  overflowCount,
}: {
  lineItems: CartLineItem[];
  overflowCount: number;
}) => {
  const { t } = useTranslate();

  if (lineItems.length === 0) return null;

  return (
    <div className="flex shrink-0 items-center" data-testid="offer-thumbnail-stack">
      <div className="flex items-center">
        {lineItems.map((lineItem, index) => (
          <div
            key={getCartLineItemKey(lineItem, index)}
            className={cn(
              'relative size-10 shrink-0 overflow-hidden rounded-[4px] border border-current bg-white shadow-[0px_2px_6px_0px_rgba(0,0,0,0.1)]',
              index > 0 && '-ml-7'
            )}
          >
            <img
              src={getCartLineItemAssetUrl(lineItem)}
              alt={getCartLineItemDisplayName(lineItem)}
              className="size-full object-contain"
            />
          </div>
        ))}
      </div>
      {overflowCount > 0 && (
        <div
          className="-ml-4 flex h-6 min-w-7 items-center justify-center rounded-full bg-black px-1.5 backdrop-blur-sm"
          data-testid="offer-overflow-badge"
        >
          <span className="text-[10px] font-bold leading-[15px] text-white">
            {t('offersOverflow', { count: overflowCount })}
          </span>
        </div>
      )}
    </div>
  );
};
